<template>
  <div style="margin-bottom:10px">
    <div v-if="tags" class="line-chart-box">
      <div
        v-for="(item, index) in lineChat"
        v-if="index < tags.length"
        :key="item.class"
        :class="`tag ${item.class}`"
      >
        <p v-if="type === 'object'">
          <span>{{ tags[item.index].tag }}</span>
          <span v-if="showTagLabel(tags[item.index])"
            >（{{ tags[item.index].label }}）</span
          >
        </p>
        <span v-else>{{ tags[item.index] }}</span>
      </div>
    </div>
    <div v-if="type === 'object'" class="tagsort-box">
      <el-tag
        v-for="(tag, index) in tags"
        v-if="index > 4&&!onlyTopFive"
        :key="tag.tag"
        size="small"
        class="custom-primary-plain mr10 mb15"
      >
        {{ tag.tag }} <span v-if="showTagLabel(tag)">（{{ tag.label }}）</span>
      </el-tag>
    </div>
    <div v-else-if="type === 'string'" class="tagsort-box">
      <el-tag
        v-for="(tag, index) in tags"
        v-if="index > 4&&!onlyTopFive"
        :key="tag"
        size="small"
        class="custom-primary-plain mr10 mb15"
      >
        {{ tag }}
      </el-tag>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tags: { type: Array, default: () => [] },
    onlyTopFive: { type: Boolean, default: false },
  },
  data() {
    return {
      lineChat: [
        { index: 0, class: 'first' },
        { index: 1, class: 'second' },
        { index: 2, class: 'third' },
        { index: 3, class: 'fourth' },
        { index: 4, class: 'fifth' },
      ],
    }
  },
  computed: {
    type() {
      return typeof this.tags[0]
    },
  },
  methods: {
    showTagLabel(tag) {
      const showTypes = ['平台', '业绩']
      return !!showTypes.includes(tag.label)
    },
  },
}
</script>
<style scoped>
.line-chart-box {
  padding: 15px 0;
}
.tag {
  color: #fff;
  text-align: center;
  line-height: 22px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  margin-bottom: 6px;
}
.first {
  background-color: #fbdee0;
  color: #de5c65;
  width: 100%;
  min-width: 245px;
}
.second {
  background-color: #fce1b8;
  width: 90%;
  min-width: 210px;
  color: #ed9f2b
}
.third {
  background-color: #CBE9F4;
  color:#2E99BF;
  width: 80%;
  min-width: 170px;
}
.fourth {
  background-color: #E6F0FA;
  color:#3D5C72;
  width: 70%;
  min-width: 130px;
}
.fifth {
  background-color: #D1EAE6;
  color:#64B9A1;
  width: 60%;
  min-width: 90px;
}
</style>
